import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Ban } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, money } from "@/lib/api";

export const VoidDialog = ({ invoice, onClose, onDone }) => {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  if (!invoice) return null;

  const go = async () => {
    setBusy(true);
    try {
      const { data } = await api.patch(`/invoices/${invoice.id}/status`, { status: "void", void_reason: reason });
      toast.success(`${invoice.invoice_number} voided`);
      onDone(data);
      onClose();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm" data-testid="void-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2 text-red-600"><Ban className="h-5 w-5" /> Void {invoice.invoice_number}</DialogTitle>
          <DialogDescription>{invoice.client?.name} · {money(invoice.total)}. Voided invoices are kept for your records but excluded from all totals. You can restore it later.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-1.5">
            <Label>Reason (optional)</Label>
            <Textarea data-testid="void-reason-input" rows={3} value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Wrong amount, duplicate, job cancelled..." />
          </div>
          <Button data-testid="void-confirm-button" disabled={busy} onClick={go} className="w-full h-11 bg-red-600 hover:bg-red-700 text-white font-bold">
            {busy ? "Voiding..." : "Void invoice"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
